import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PlanUpgrade from "../PlanUpgrade";

import {
  addActivities,
  removeDocumentActivities,
} from "../../actions/DocumentActions/index";
import { ACTIVITY_EVENT_MESSAGE } from "../../constants/activities";
import { formatDate } from "../../utils/globalUtils";

const Activity = ({
  objectId,
  activities,
  addActivities: addActivitiesAction,
  removeDocumentActivities: removeActivities,
  featureName,
}) => {
  // call when object id changes
  useEffect(() => {
    addActivitiesAction(objectId, null, null, 10, false).catch(() => {});

    return () => {
      // remove activities
      removeActivities();
    };
  }, [addActivitiesAction, objectId, removeActivities]);

  return (
    <div className="context-activity animated fadeinright">
      <div className="activity-header">
        <span className="activity-right-pane-title">Activity</span>
      </div>
      <div className="activity-content">
        <div className="activity-content-scroll">
          <div className="activity-info">
            This is a record of all activities associated with this document.
          </div>
          {/* <div className="activity-section-title">
            This is not there, also change class names
          </div> */}
          {activities && activities.length ? (
            activities
              .slice(0, 3)
              .map(({ actor, event, timestamp, subjects }) => (
                <Fragment>
                  {ACTIVITY_EVENT_MESSAGE[event] ? (
                    <div className="activity-users">
                      <div className="activities-event-icon">
                        {" "}
                        <span className={`activity-check ${event}`}>
                          <FontAwesomeIcon icon={["far", "check"]} />
                        </span>
                        <div className="activities-date">
                          {formatDate(timestamp, "lll")}
                        </div>
                      </div>
                      <div className="activities-user-card">
                        <div className="activity-user-imgwrapper">
                          <img
                            className="activity-user-img"
                            src={actor.image_url}
                            alt=""
                          />
                        </div>
                        <div className="activity-event-wrapper">
                          <span className="activity-user-name">
                            {actor.name}
                          </span>
                          <span className="activity-user-email">
                            {actor.user_email}
                          </span>
                          <span className="activity-user-event">
                            {ACTIVITY_EVENT_MESSAGE[event] &&
                              ACTIVITY_EVENT_MESSAGE[event](subjects)}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    console.debug(`${event} event is not handled`)
                  )}
                </Fragment>
              ))
          ) : (
            <div className="activity-no-users-message">No activities</div>
          )}
        </div>
        <div className="activity-upgrade-container">
          <div className="activity-upgrade-txt">
            To see rest of the activities, upgrade to premium plan
          </div>
          <PlanUpgrade type={featureName} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ DocumentStore }) => {
  const { document: { objectId = "" } = {}, activities } = DocumentStore;

  return {
    objectId,
    activities,
  };
};

Activity.defaultProps = {
  activities: [],
};

Activity.propTypes = {
  objectId: PropTypes.string.isRequired,
  addActivities: PropTypes.func.isRequired,
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      event: PropTypes.string.isRequired,
      timestamp: PropTypes.string.isRequired,
      actor: PropTypes.shape({
        name: PropTypes.string.isRequired,
        user_email: PropTypes.string.isRequired,
        image_url: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ),
};

const mapDispatchToProps = {
  addActivities,
  removeDocumentActivities,
};

export default connect(mapStateToProps, mapDispatchToProps)(Activity);
